module.exports = __webpack_public_path__ + "img/dis3.91c0fe54.png";